import React from "react";
import Calendar from "rc-calendar";
import moment from "moment";

import utils from '../lib/utils';

import { COURSE, COURSE_API } from "../utils/Req";
import { Utils } from "../utils/Utils";
import { setUserStorage } from '../server/commonFun';

import "rc-calendar/dist/rc-calendar.css";
import "../static/css/baby-info.scss";

const data = [
	"A",
	"B",
	"C",
	"D",
	"E",
	"F",
	"G",
	"H",
	"I",
	"J",
	"K",
	"L",
	"M",
	"N",
	"O",
	"P",
	"Q",
	"R",
	"S",
	"T",
	"U",
	"V",
	"W",
	"X",
	"Y",
	"Z"
];

export default class BabyInfo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			boyName: [],
			girlName: [],
			sex: 0,
			name: "",
			tempName: "",
			birthday: "",
			learnEnglishTime: 0,
			photo: "",
			showChooseName: false,
			selected: "",
			showCalendar: false,
			showNamesListSure: false,
			errmsg: "",
			infomsg: "",
			showTabIndex: 0,
			examRecords: null,
			examState: -1  //0-不显示;1-开始测试;2-重新测试
		};
		this.PutaoID = Utils.getCookie("putaoid");
		this.Token = encodeURIComponent(Utils.getCookie("token"));
	}

	// 获取孩子的名字
	componentDidMount() {

		const req = `${COURSE_API.kid_names}?putaoid=${this.PutaoID}&token=${
			this.Token
			}&from=pc`;

		fetch(req, { method: "GET" })
			.then(response => response.json())
			.then(data => {
				console.log(data);
				if (data.code === 200) {
					this.setState({
						boyName: data.boy,
						girlName: data.girl
					});
				} else if (data.code === 499) {
					window.location = `${window.location.pathname}${window.location.search}#/login?redirect=baby-info`;
				}
			});

		// 获取用户信息
		fetch(
			`${COURSE_API.user}?putaoid=${this.PutaoID}&token=${this.Token}&from=pc`,
			{ method: "GET" }
		)
			.then(res => res.json())
			.then(data => {
				console.log("用户信息", data);
				if (data.code === 200) {
					this.setState({
						sex: data.gender,
						name: data.eng_name,
						birthday: data.birth ? moment(data.birth).format("YYYY-MM-DD") : "",
						learnEnglishTime: data.learnEnglishTime || "0基础",
						photo: data.photo
					}, () => {
						setUserStorage(data);
					});
				} else if (data.code === 499) {
					window.location = `${window.location.pathname}${window.location.search}#/login?redirect=baby-info`;
				}
			});
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	//   点击切换性别
	sexChangeHandler(sex) {
		if (sex === 0) {
			this.setState({
				sex
			});
		} else if (sex === 1) {
			this.setState({
				sex
			});
		}
	}

	// 输入框改变
	inputOnChangeHandler(e, key) {
		e.preventDefault();

		this.setState({
			[key]: e.target.value
		});
	}

	//   保存宝贝信息
	saveBabyInfoHandler() {
		const { sex, name, birthday, learnEnglishTime, photo } = this.state;
		if (!((sex === 0 || sex === 1) && name && learnEnglishTime)) {// && birthday
			// this.addToast('要把信息填写完整哦！');
			this.setState({ errmsg: "要把信息填写完整哦！" });
			this.timer = setTimeout(() => {
				this.setState({
					errmsg: ""
				});
			}, 3000);
		} else {
			const req = `${COURSE_API.add_user}?putaoid=${this.PutaoID}&token=${
				this.Token
				}&gender=${sex}&birth=${birthday}&learnEnglishTime=${learnEnglishTime}&enName=${name}&photoUrl=${photo}&from=pc`;

			fetch(req, { method: "GET" })
				.then(res => res.json())
				.then(data => {
					console.log(data);
					if (data.code === 200) {
						this.addToast("保存成功");
					}
				});
		}
	}

	chooseNameHandler(e) {
		var allNames = document.querySelectorAll(".all-names");
		for (let i = 0; i < allNames.length; i++) {
			allNames[i].setAttribute("class", "all-names");
		}

		e.target.className = "all-names active";
		this.setState({ selected: e.target.innerHTML }, () => {
			this.playNameHandler();
		});
	}

	playNameHandler() {
		var audioElement = document.getElementById("playName");
		audioElement.src = `https://course-app-1256571289.cos.ap-beijing.myqcloud.com/kid_name/${this.state.selected.toLocaleLowerCase()}.mp3`;
	}

	// 改变日期
	getCalendarHandler() {
		var calendarInput = document.querySelector(".rc-calendar-input");
		let value = new Date(calendarInput.value).getTime();

		if (value > new Date().getTime()) {
			utils.showTips('请选择今天之前的日期哦~', 2000);
		} else {
			this.setState({
				birthday: calendarInput.value,
				showCalendar: false
			});
		}
	}

	// 点击空白处关闭选择日期的弹框
	colseCalendarHandler(e) {
		// e.preventDefault();

		if (
			e.target.className.indexOf("rc-calendar") < 0 &&
			e.target.className !== "input-baby-birthday" &&
			e.target.className !== "baby-birthday-pull"
		) {
			this.setState({
				showCalendar: false
			});
		}
	}

	fileInputOnChangeHandler() {
		var input = document.querySelector('input[type="file"]');

		var data = new FormData();
		// console.log(input.files[0]);
		if (input.files[0]) {
			if (input.files[0].size > 1000000) {
				this.addToast("图片大小超出限制");
			} else {
				data.append("file", input.files[0]);
				data.append("name", "file");
				fetch(
					`${COURSE_API.upload_image}?putaoid=${this.PutaoID}&token=${
					this.Token
					}&from=pc`,
					{
						method: "POST",
						body: data
					}
				)
					.then(res => res.json())
					.then(data => {
						console.log("上传图片", data);
						if (data.code === 200) {
							this.addToast("上传成功");
							this.setState({ photo: data.imageUrl });
							// this.setState({ infomsg: "上传成功", photo: data.imageUrl });
							// this.timer = setTimeout(() => {
							//   this.setState({ infomsg: "" });
							// }, 2000);
						}
					});
			}
		}
	}

	// 添加提示
	addToast(text) {
		this.setState({ infomsg: text });
		this.timer = setTimeout(() => {
			this.setState({
				infomsg: ""
			});
		}, 2000);
	}

	handleChangeBadyTab(index) {
		const that = this;
		this.setState({
			showTabIndex: index
		}, () => {
			if (index === 1) {
				that.getExamRecords();
			}
		});
	}

	getExamRecords() {
		const that = this;
		const { examRecords } = that.state;
		if (!examRecords) {
			fetch(
				`${COURSE_API.exam_records}?putaoid=${that.PutaoID}&token=${that.Token}&from=pc`,
				{ method: "GET" }
			)
				.then(res => res.json())
				.then(data => {
					if (data.code === 200 && data.data) {
						let useLevelExamRecord = [];
						if (data.data.levelExamRecord && data.data.levelExamRecord instanceof Array) {
							let levelExamRecord = data.data.levelExamRecord;
							let newLevelExamRecord;
							if (levelExamRecord.length > 3) {
								newLevelExamRecord = levelExamRecord.slice(-3);
							} else {
								newLevelExamRecord = levelExamRecord;
							}

							let c = document.getElementById('evaluationCanvas');
							let ctx = c.getContext("2d");
							let useWidth = 380 / (newLevelExamRecord.length - 1);
							let useHeight = 200;
							let maxLevel = 1;
							ctx.width = 380;
							ctx.height = 200;

							for (let i = 0; i < newLevelExamRecord.length; i++) {
								let item = newLevelExamRecord[i];

								// level 等于0的时候会有问题
								if (item.level === 0) {
									item.level = 1;
								}

								maxLevel = item.level > maxLevel ? item.level : maxLevel;
								let itemExamRecord = {
									level: item.level,
									levelShow: item.levelShow,
									levelUrl: item.levelUrl,
									finishTime: item.finishTime && item.finishTime.length ? item.finishTime.split(' ')[0] : item.finishTime
								}
								useLevelExamRecord.push(itemExamRecord);
							}

							that.setState({
								examRecords: useLevelExamRecord || [],
								examState: data.data.state
							}, () => {
								ctx.beginPath();
								if (newLevelExamRecord[0] && newLevelExamRecord[0].level !== undefined) {
									ctx.moveTo(1, ((maxLevel - newLevelExamRecord[0].level) / maxLevel * useHeight) + 1);//起始位置
								}
								for (let i = 0; i < newLevelExamRecord.length; i++) {
									let item = newLevelExamRecord[i];
									let _x = useWidth * i;
									let _y = ((maxLevel - item.level) / maxLevel * useHeight) + 1;
									ctx.lineTo(_x, _y);//停止位置
									let evaluation = that.refs['evaluation' + i];
									let evaluationTime = that.refs['evaluation_time' + i];
									if (evaluation) {
										evaluation.style.top = (_y + 45) + 'px';
										evaluation.style.left = (_x - 40) + 'px';
										evaluationTime.style.left = (_x - 40) + 'px';
									}
									// $('#evaluationItem').append(`<div class="evaluation-item" style="top:${_y + 45}px;left:${_x}px;">${item.levelShow}<br /><a href="${item.levelUrl}" target="_blank">查看</a></div>`)
								}
								for (let i = newLevelExamRecord.length - 1; i >= 0; i--) {
									ctx.lineTo(useWidth * i, useHeight - 1);//停止位置
								}
								ctx.closePath();
								ctx.strokeStyle = "#FF9678";
								ctx.fillStyle = "#f8d6b6";
								ctx.fill();
								ctx.lineWidth = 1;
								ctx.stroke();
								c.style.display = 'block';
							});
						} else {
							that.setState({
								examRecords: [],
								examState: data.data.state
							});
						}

					} else if (data.code === 499) {
						window.location = `${window.location.pathname}${window.location.search}#/login?url=${encodeURIComponent(window.location.href)}`;
					}
				});
		}
	}

	render() {
		const that = this;
		const {
			name,
			tempName,
			birthday,
			learnEnglishTime,
			photo,
			showChooseName,
			sex,
			boyName,
			girlName,
			selected,
			showCalendar,
			showNamesListSure,
			errmsg,
			infomsg,
			showTabIndex,
			examRecords,
			examState
		} = this.state;

		const names = sex === 0 ? boyName : girlName;

		return (
			<div className="baby-info-box">
				<div className="skyBg" />
				<div className="go-back" onClick={() => { window.history.back(); }} />
				<div className="baby-info"
					onClick={e => { this.colseCalendarHandler(e); }}>
					{infomsg && <div className="baby-info-infomsg">{infomsg}</div>}

					{!showChooseName && (
						<div className="bady-content">
							<ul className="bady-tab">
								<li className={showTabIndex === 0 ? "active" : ""} onClick={() => that.handleChangeBadyTab(0)}>宝贝信息</li>
								<li className={showTabIndex === 1 ? "active" : ""} onClick={() => that.handleChangeBadyTab(1)}>英语等级</li>
							</ul>

							<div className="input-baby-info" style={showTabIndex === 1 ? { "display": "block" } : { "display": "none" }}>
								<div className="input-info-logo" style={{ background: photo && `url(${photo}) no-repeat center / cover` }} />
								<div className="evaluation-info-content">
									{/* <div id="evaluationItem" /> */}
									{examRecords && examRecords.length && examRecords.length > 0 ? <canvas id="evaluationCanvas" width="380" height="200" /> : <canvas id="evaluationCanvas" width="380" height="0" />}
									{
										examRecords ?
											examRecords.length ?
												examRecords.map((item, index) => {
													return (
														<div key={index}>
															<div className="evaluation-item" ref={"evaluation" + index}>
																{item.levelShow}
																<a href={item.levelUrl + "&noback=1"} target="_blank">查看</a>
															</div>
															<div ref={"evaluation_time" + index} className="evaluation-time">{item.finishTime}</div>
														</div>
													)
												})
												:
												<div className="no-result">宝贝还没有进行英语水平定级测试哦~<br /><em>5分钟测出宝贝适合的级别</em></div>
											: null
									}
								</div>
								{
									examState === 1 || examState === 2 ?
										<div className="input-info-save" onClick={() => { window.location.href = '/onlinepages/course_assist/evaluation/?v=' + Math.floor(Math.random() * 1000) }}>{
											examState === 1 ? "开始测试" : "重新测试"
										}</div>
										: null
								}
							</div>

							<div className="input-baby-info" style={showTabIndex === 0 ? { "display": "block" } : { "display": "none" }}>
								<div
									className="input-info-logo"
									style={{
										background:
											photo && `url(${photo}) no-repeat center / cover`
									}}
								>
									<input
										type="file"
										id="fileInput"
										name="file"
										accept="image/jpg,image/jpeg,image/png"
										onChange={() => {
											this.fileInputOnChangeHandler();
										}}
									/>
								</div>
								<div className="input-info-content">
									<div className="input-info-avator">
										<div
											className={sex === 0 ? "male-baby active" : "male-baby"}
											onClick={() => {
												this.sexChangeHandler(0);
											}}
										/>
										<div
											className={sex === 1 ? "girl-baby active" : "girl-baby"}
											onClick={() => {
												this.sexChangeHandler(1);
											}}
										/>
									</div>
									<div
										className="input-box"
										onClick={() => {
											this.setState({ showChooseName: true, tempName: name });
										}}
									>
										<span className="label">英文名</span>
										<input
											placeholder="宝宝英文名"
											className="input-baby-name"
											value={name}
											onChange={e => {
												this.inputOnChangeHandler(e, "name");
											}}
										/>
										<div className="baby-name-pull" />
									</div>
									<div
										className="input-box"
										id="data-picker-is-show"
										onClick={() => {
											this.setState({ showCalendar: true });
										}}
									>
										<span className="label">英语基础</span>
										{/* <input
											placeholder="英语基础"
											className="input-baby-birthday"
											value={learnEnglishTime}
											onChange={e => {
												this.inputOnChangeHandler(e, "learnEnglishTime");
											}}
										/> */}
										<select
											placeholder="英语基础"
											value={learnEnglishTime}
											onChange={e => {
												this.inputOnChangeHandler(e, "learnEnglishTime");
											}}>
											<option value={0}>0基础</option>
											<option value={1}>少于1年</option>
											<option value={2}>1-2年</option>
											<option value={3}>2年以上</option>
										</select>
										<div className="baby-birthday-pull" />
									</div>
									{/* <div
										className="input-box"
										id="data-picker-is-show"
										onClick={() => {
											this.setState({ showCalendar: true });
										}}
									>
										<input
											placeholder="宝宝生日"
											className="input-baby-birthday"
											value={birthday}
											onChange={e => {
												this.inputOnChangeHandler(e, "birthday");
											}}
										/>
										<div className="baby-birthday-pull" />
									</div> */}
								</div>
								{errmsg && <div className="baby-info-errmsg">{errmsg}</div>}
								<div className="input-info-save"
									style={{
										background: name !== "" && birthday !== ""
											? `url(${require("../static/img/baby-info/button-background-active.png")}) no-repeat center / contain'`
											: ""
									}}
									onClick={() => {
										this.saveBabyInfoHandler();
									}}>保存</div>
							</div>

						</div>
					)}

					{showChooseName && (
						<div style={{ position: "fixed" }}>
							<div className="choose-name">
								<div className="choose-name-header">
									<div className="choose-name-links">
										{Array.isArray(data) &&
											data.map((value, index) => (
												<a href={`#/baby-info?t=${value}`} key={index}>
													{value}
												</a>
											))}
									</div>
									<div className="input-info-avator choose-name-sex">
										<div
											className={sex === 0 ? "male-baby active" : "male-baby"}
											onClick={() => {
												this.sexChangeHandler(0);
											}}
										/>
										<div
											className={sex === 1 ? "girl-baby active" : "girl-baby"}
											onClick={() => {
												this.sexChangeHandler(1);
											}}
										/>
									</div>
									<div className="choose-name-input-box">
										<input
											placeholder="请输入用户名"
											className="choose-name-input"
											defaultValue={name}
											value={tempName}
											maxLength="20"
											onChange={e => {
												this.inputOnChangeHandler(e, "tempName");
											}}
											onFocus={() => {
												this.setState({ showNamesListSure: true });
											}}
										/>
										{showNamesListSure && (
											<div
												className="choose-name-input-sure-button"
												onClick={e => {
													if (tempName) {
														this.setState({
															showChooseName: false,
															showNamesListSure: false,
															name: tempName
														});
													}
												}}
											>确定</div>
										)}
									</div>
									{selected && (
										<div>
											<div
												className="selected-name"
												onClick={() => {
													this.playNameHandler();
												}}
											>
												{selected}
												<audio autoPlay id="playName" />
											</div>
											<div
												className="save-selected-name"
												onClick={() => {
													this.setState({
														name: selected,
														showChooseName: false
													});
												}}
											>
												确定
                      </div>
										</div>
									)}
								</div>

								{/* {showNamesListSure && (
                  <div className="input-name-list-mask">
                    <div className="input-name-list-mask" />
                  </div>
                )} */}
								<div className="choose-name-content-box">
									{Array.isArray(names) &&
										names.map((value, index) => (
											<div
												className="choose-name-content"
												key={index}
												id={`/baby-info?t=${value.name}`}
											>
												<div className="choose-name-content-header">
													{value.name === "hot" ? "热门名字" : value.name}
												</div>
												<div className="choose-name-content-names">
													{Array.isArray(value.list) &&
														value.list.map((x, index) => (
															<div
																key={x}
																className="all-names"
																onClick={e => {
																	this.chooseNameHandler(e);
																}}
															>
																{x}
															</div>
														))}
												</div>
											</div>
										))}
								</div>
							</div>
							<div className="close-choose-name" onClick={() => { this.setState({ showChooseName: false }); }} />
						</div>
					)}
					{showCalendar && (
						<div className="rc-ralendar-container">
							<Calendar
								className="rc-ralendar-input"
								format="YYYY-MM-DD"
								activeStartDate="2012-12-12"
								defaultValue={moment(1355270400000)}
							/>
							<div className="rc-calendar-button">
								<div
									className="rc-calendar-cancle"
									onClick={() => {
										this.setState({ showCalendar: false });
									}}
								>取消</div>
								<div
									className="rc-calendar-sure"
									onClick={() => {
										this.getCalendarHandler();
									}}
								>确定</div>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/route/BabyInfo.js